import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { GetgtmidService} from './app/spartacus/services/getgtmid.service'

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));


